export function formatPrice(value, locale = "en-US", currency = "USD") {
    if (value == null || value === "") return null;
    const number = Number(value);
    if (isNaN(number)) return null;

    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);
}
